import { format } from 'date-fns';
import Flatpickr from 'react-flatpickr';

const preventInvalidNumberKeys = (event) => {
    if (['e', 'E', '+', '-'].includes(event.key)) {
        event.preventDefault();
    }
};

const DateTimeField = ({ formData, formErrors, onChangeDateTime }) => (
    <div className="d-flex flex-column mb-3">
        <label htmlFor="booking-datetime" className="form-control-label">
            Consultation Date &amp; Time<span className="text-danger"> *</span>
        </label>
        <Flatpickr
            className="form-control"
            id="booking-datetime"
            placeholder="YYYY-MM-DD HH:MM"
            value={formData.DateAndTime}
            onChange={onChangeDateTime}
            options={{ enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: false, minDate: format(new Date(), 'yyyy-MM-dd') }}
        />
        {formErrors.DateAndTime && <p className="text-danger m-0">{formErrors.DateAndTime}</p>}
    </div>
);

const AmountFields = ({ discountField, formData, onChangeHandler }) => (
    <>
        <div className="d-flex flex-column mb-3">
            <label className="form-control-label">Discount Percentage (<span className="text-danger">%</span>)</label>
            <input
                type="number"
                name={discountField}
                className="form-control"
                placeholder="Enter Discount Percentage"
                value={formData[discountField] ?? ''}
                min={0}
                max={100}
                onChange={onChangeHandler}
                onKeyDown={preventInvalidNumberKeys}
            />
        </div>
        {['PaidAmount', 'TotalAmount'].map((name) => (
            <div className="d-flex flex-column mb-3" key={name}>
                <label className="form-control-label">{name === 'PaidAmount' ? 'Paid Amount' : 'Total Amount'} (<i className="bi bi-currency-rupee text-danger"></i>)</label>
                <input
                    type="number"
                    name={name}
                    className="form-control"
                    placeholder={`Enter ${name === 'PaidAmount' ? 'Paid' : 'Total'} Amount`}
                    value={formData[name] ?? ''}
                    min={0}
                    max={999999}
                    onChange={onChangeHandler}
                    onKeyDown={preventInvalidNumberKeys}
                />
            </div>
        ))}
    </>
);

const BookingApprovalForm = ({
    formData,
    formErrors,
    handleSubmit,
    onChangeDateTime,
    onChangeHandler,
    serviceTypes,
    submitLoading,
}) => {
    const policyId = formData.HospitalPoliciesId;
    const isConsultation = policyId === 1;
    const isLab = policyId === 2;
    const title = isConsultation ? 'Free Consultation' : isLab ? 'Booking Lab Investigation' : 'Pharmacy Discount';

    return (
        <div className="p-3 text-start">
            <h4 className="mb-5 text-center">
                {title} for <br />
                <span style={{ color: '#0E94C3' }} className="fs-5 text-success">{formData.FullName}</span>
            </h4>
            <form onSubmit={handleSubmit}>
                <div className="d-flex flex-column align-items-start" style={{ minWidth: '350px' }}>
                    {(isConsultation || isLab) && (
                        <DateTimeField formData={formData} formErrors={formErrors} onChangeDateTime={onChangeDateTime} />
                    )}
                    {isConsultation && (
                        <>
                            <div className="d-flex flex-column mb-3">
                                <label className="form-control-label" htmlFor="doctor-name">Doctor Name</label>
                                <input id="doctor-name" type="text" name="DoctorName" className="form-control" placeholder="Enter Doctor Name" value={formData.DoctorName ?? ''} onChange={onChangeHandler} />
                            </div>
                            <div className="d-flex flex-column mb-3">
                                <label className="form-control-label" htmlFor="service-type">Service Type<span className="text-danger"> *</span></label>
                                <select id="service-type" name="ServiceType" className="form-control" value={formData.ServiceType ?? ''} onChange={onChangeHandler}>
                                    <option value="">--- SELECT ---</option>
                                    {serviceTypes.map((type) => <option key={type.HospitalServicesId} value={type.HospitalServicesId}>{type.ServiceName}</option>)}
                                </select>
                                {formErrors.ServiceType && <p className="text-danger m-0">{formErrors.ServiceType}</p>}
                            </div>
                        </>
                    )}
                    {!isConsultation && <AmountFields discountField={isLab ? 'LabPercentage' : 'PharmacyPercentage'} formData={formData} onChangeHandler={onChangeHandler} />}
                </div>
                <div className="text-center">
                    <button type="submit" className="btn btn-success" style={{ width: '80px', height: '40px' }} disabled={submitLoading}>
                        {submitLoading ? <span className="spinner-border text-white" role="status" aria-hidden="true"></span> : 'Accept'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default BookingApprovalForm;
